import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class CuentaBancariaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerCuentaEmpresa(empresa_rut, banco_codigo, activo, callback: Function) {
    const inputParams = {
      entidad: {
        empresa_rut,
        banco_codigo,
        activo,
      }
    }

    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: cuenta_bancariaInputType) {
          cuenta_bancaria {
            obtenerCuentaEmpresa(entidad: $entidad) {
              respuesta {
                registros {
                  empresa_rut
                  tipo_cuenta_bancaria_codigo
                  banco_codigo
                  numero_cuenta
                  observaciones
                  activo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cuenta_bancaria.obtenerCuentaEmpresa
        callback({ mensajes, respuesta })
      }
    );
  }

}
